/* eslint-disable class-methods-use-this, prefer-destructuring, no-undef, no-shadow, no-unused-vars */

class SearchForm {
	constructor() {
		this.searchForms = document.getElementsByClassName("search-form");
		if (this.searchForms[0]) {
			this.init();
		}
	}

	init() {
		const displaySearchForm = window.getComputedStyle(
			this.searchForms[0]
		).display;
		const searchButton = document.querySelector(".js-search-button");
		const searchButtonIcon = document.querySelector(".search-form__icon");
		const searchButtonClose = document.querySelector(".search-close__icon");
		function addSearchClass() {
			searchButton.classList.add("search-close");
		}
		function removeSearchClass() {
			searchButton.classList.remove("search-close");
		}

		if (searchButtonIcon) {
			searchButtonIcon.addEventListener("click", addSearchClass);
		}

		if (searchButtonClose) {
			searchButtonClose.addEventListener("click", removeSearchClass);

			if (displaySearchForm === "none") {
				removeSearchClass();
			}
		}
	}
}

export default SearchForm;
